import LinksBreadcrumbs from './LinksBreadcrumbs';

export default LinksBreadcrumbs;
